/* RESPONSIBLE TEAM: team-standalone */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { dropTask } from 'ember-concurrency-decorators';
import { post } from 'embercom/lib/ajax';
import { taskFor } from 'ember-concurrency-ts';
import { captureException } from '@sentry/browser';
import { type TaskGenerator } from 'ember-concurrency';
import type Store from '@ember-data/store';
import type RouterService from '@ember/routing/router-service';
import type ReportingMetrics from 'embercom/services/reporting-metrics';
import type ReportingViews from 'embercom/services/reporting-views';
import type ReportingTemplates from 'embercom/services/reporting-templates';
import type Report from 'embercom/models/reporting/custom/report';

export default class FinStandaloneReportsCustomReportRoute extends Route {
  @service declare appService: any;
  @service declare router: RouterService;
  @service declare reportingMetrics: ReportingMetrics;
  @service declare reportingViews: ReportingViews;
  @service declare reportingTemplates: ReportingTemplates;
  @service declare store: Store;

  async beforeModel() {
    let promises = [];
    promises.push(taskFor(this.reportingMetrics.setup).perform());
    promises.push(taskFor(this.reportingViews.setUp).perform());
    promises.push(this.reportingTemplates.loadTemplates());
    await Promise.all(promises);
    let defaultReport = this.reportingViews.standaloneDefaultReport;
    if (!defaultReport) {
      try {
        defaultReport = await taskFor(this.createReport).perform();
        this.store.pushPayload(defaultReport);
      } catch (e) {
        captureException(e);
        console.error(e);
        return await this.router.transitionTo('apps.app.standalone.reports.overview');
      }
    }
    return await this.router.transitionTo(
      'apps.app.standalone.reports.report.show',
      defaultReport.id,
    );
  }

  @dropTask *createReport(): TaskGenerator<Report> {
    return yield post(`/ember/standalone/reporting/create_default_report`, {
      app_id: this.appService.app.id,
    });
  }
}
